<template>
  <div id="data-view">
    <dv-full-screen-container>
      <div class="main-header">
        <div class="mh-middle" style="color:#67abf4">数据可视化</div>
      </div>

      <dv-border-box-1 class="main-container">
        <LeftChart :alarmData="alarmData" :windowWidth=windowWidth ref="LeftChart"></LeftChart>

        <div class="right-main-container">
          <div class="rmc-top-container">
            <MainChart :personData="personData"  :windowWidth=windowWidth ref="MainChart"></MainChart>

            <div class="rmctc-right-container">
              <RightChart :areaData="areaData" :windowWidth=windowWidth ref="RightChart"></RightChart>
            </div>
          </div>

          <dv-border-box-8 class="rmc-bottom-container">
            <BottomChart :stateData="stateData" :windowWidth=windowWidth ref="BottomChart"></BottomChart>
          </dv-border-box-8>
        </div>
      </dv-border-box-1>

    </dv-full-screen-container>
  </div>
</template>

<script>
import { httpModel } from "../../http/httpModel";
import LeftChart from './components/LeftChart'
import MainChart from './components/MainChart'
import RightChart from './components/RightChart'
import BottomChart from './components/BottomChart'
export default {
  name: 'DashBoard',
  components:{
    LeftChart,
    MainChart,
    RightChart,
    BottomChart
  },
  data() {
    return {
      windowWidth: 0,
      intervalId:null,
      alarmData:{
        totalAlarmCount: 0,
        dealAlarmCount: 0,
        dealRate: 0,
        todayAlarmCount: 0,
        alarmChangeCount: 0,
        data: [],
        types:[]
      },
      areaData:{
        data:[]
      },
      personData:{
        totalCount: 0,
        bindCount:0,
        groupData: []
      },
      stateData:{
        scoutCount:0,
        trialCount:0,
        reviewCount:0,
        finishCount:0,
        optionData:{
          times:[],
          scoutData:[],
          trialData: [],
          reviewData:[],
          finishDate:[]
        }
      },
    }
  },
  methods:{
    queryData() {
      httpModel.statistics({
      }).then((resp) => {
        let { code, result } = resp;
        if (code == 0) {
          if(result['告警']){
            this.alarmData =
                {
                  totalAlarmCount: 0,
                  dealAlarmCount: 0,
                  dealRate: 0,
                  todayAlarmCount: 0,
                  alarmChangeCount: 0,
                  data: [],
                  types:[]
                }
            if(result['告警']['告警总数']){
              this.alarmData.totalAlarmCount = result['告警']['告警总数']
            }
            if(result['告警']['已处理']){
              this.alarmData.dealAlarmCount = result['告警']['已处理']
            }
            if(result['告警']['处理率']){
              this.alarmData.dealRate = parseFloat(result['告警']['处理率'].substring(0,result['告警']['处理率'].length - 1))
            }
            if(result['告警']['今日告警']){
              this.alarmData.todayAlarmCount = result['告警']['今日告警']
            }
            if(result['告警']['较昨日']){
              this.alarmData.alarmChangeCount = result['告警']['较昨日']
            }
            if(result['告警']['记录']){
              result['告警']['记录'].map(item =>
                  this.alarmData.data.push([
                    item['人员'],
                    item['时间']
                  ])
              )
              console.log( this.alarmData.data)
            }
            if(result['告警']['统计'] && result['告警']['统计']['list']){
              result['告警']['统计']['list'].map(item => {
                if (item.num != 0) {
                  this.alarmData.types.push({
                    name: item.name,
                    value: item.num
                  })
                }
              })
            }
          }

          if(result['人员统计']){
            this.areaData.data = []
            this.areaData.data.push(['室外', result['人员统计']['室外']['人数'] + ''])
            this.areaData.data.push(['室内', result['人员统计']['室内']['人数'] + ''])
            if(result['人员统计']['室内']['人数'] != 0){
              result['人员统计']['室内']['详情'].map(item => {
                this.areaData.data.push([item['楼层'], item['人数'] + ''])
                if(item['详情']){
                  item['详情'].map(subItem => {
                    this.areaData.data.push([item['楼层'] + ' -> ' + subItem['区域'], subItem['人数'] + ''])
                  })
                }
              })
            }
          }

          if(result['人数']){
            this.personData = {
              totalCount: 0,
              bindCount:0,
              groupData: []
            }
            if(result['人数']['总计']){
              this.personData.totalCount = result['人数']['总计']
            }
            if(result['人数']['绑定']){
              this.personData.bindCount = result['人数']['绑定']
            }
          }

          if(result['分组']){
            if(result['分组']['详情']){
              result['分组']['详情'].map(item => {
                this.personData.groupData.push({
                  name: item['名称'],
                  value: item['人数']
                })
              })
            }
          }

          this.$nextTick(()=>{
            this.$refs['LeftChart'].refreshData();
            this.$refs['MainChart'].refreshData();
            this.$refs['RightChart'].refreshData();
            this.$refs['BottomChart'].refreshData();
          })

        }
      })
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    this.queryData()
    this.intervalId = setInterval(this.queryData,1000 * 60)
  }
}
</script>

<style lang="less">
#data-view {
  width: 100%;
  height: 100%;
  background-color: #030409;
  color: #fff;

  .active-ring-name {
    font-size: 1.1vw !important;
    color:#18cce9  !important;
  }

  #dv-full-screen-container {
    background-image: url('/img/bg.png');
    background-size: 100% 100%;
    box-shadow: 0 0 3px blue;
    display: flex;
    flex-direction: column;
  }

  .dv-scroll-board .rows .row-item {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 0.7vw;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }


  .main-header {
    height: 80px;
    text-align: center;
    .mh-middle {
      margin-top:30px;
      font-size: 30px;
    }
  }

  .main-container {
    height: calc(~"100% - 140px");

    .border-box-content {
      padding: 20px;
      box-sizing: border-box;
      display: flex;
    }
  }



  .right-main-container {
    width: 78%;
    padding-left: 5px;
    box-sizing: border-box;
  }

  .rmc-top-container {
    height: 65%;
    display: flex;
  }



  .rmctc-right-container {
    width: 35%;
    .border-box-content {
      flex-direction: column;
    }
  }

  .rmc-bottom-container {
    .border-box-content {
      flex-direction: column;
    }
    height: 35%;
  }

}
</style>
